import type { IResponse } from '@ts/interfaces/api.interfaces';
import api from '@/api.queue.instance';

export const getGlobalData = async (): Promise<IResponse> => (await api.get('static-data')).data;

export const notificationsClose = async (id: number): Promise<IResponse> =>
    (await api.post('notifications/close', { data: { id } })).data;
